// Modal to edit a task's RACI owners. Wraps RaciPicker.
// PUT /tasks/:id/owners atomically replaces the list.

import { useState } from 'react';
import { RaciPicker } from './RaciPicker.jsx';

export const OwnersEditModal = ({ task, staff, replaceOwners, onClose }) => {
  // RaciPicker uses { staffId, role, isPrimary } shape internally;
  // map from API shape (which already matches today).
  const initial = (task.owners || []).map(o => ({
    staffId: o.staffId, role: o.role, isPrimary: !!o.isPrimary
  }));
  // Legacy safety: if no R is flagged primary on a multi-R task, mark the
  // first R locally so the UI shows a star and a save won't accidentally
  // demote everyone. The worker would default-promote on save anyway.
  if (initial.some(o => o.role === 'R') && !initial.some(o => o.role === 'R' && o.isPrimary)) {
    const idx = initial.findIndex(o => o.role === 'R');
    if (idx >= 0) initial[idx] = { ...initial[idx], isPrimary: true };
  }
  const [owners, setOwners] = useState(initial);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  async function save() {
    const hasR = owners.some(o => o.role === 'R');
    if (!hasR) { setErr('至少要有 1 个 R 负责人'); return; }
    setErr('');
    setSaving(true);
    try {
      await replaceOwners(task.id, owners.map(o => ({
        staff_id: o.staffId, role: o.role, is_primary: !!o.isPrimary
      })));
      onClose();
    } catch (e) {
      setErr(e.message || '保存失败');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="vava-modal-backdrop" onClick={onClose}>
      <div className="vava-modal" onClick={(e) => e.stopPropagation()}>
        <div className="vava-modal-head">
          <h2>编辑负责人 · RACI</h2>
          <button className="vava-modal-close" onClick={onClose} aria-label="关闭">×</button>
        </div>
        <div className="vava-modal-body">
          <div className="vava-field">
            <label className="vava-label">负责人 · RACI *</label>
            <RaciPicker owners={owners} staff={staff} onChange={setOwners} />
          </div>
          {err && <div className="att-error" role="alert">{err}</div>}
        </div>
        <div className="vava-modal-foot">
          <button className="btn btn-secondary" onClick={onClose} disabled={saving}>取消</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}>
            {saving ? '保存中…' : '保存'}
          </button>
        </div>
      </div>
    </div>
  );
};
